import { render, staticRenderFns } from "./TableViewColumnPickerFieldItems.vue?vue&type=template&id=61090abc&scoped=true&"
import script from "./TableViewColumnPickerFieldItems.vue?vue&type=script&lang=js&"
export * from "./TableViewColumnPickerFieldItems.vue?vue&type=script&lang=js&"
import style0 from "./TableViewColumnPickerFieldItems.vue?vue&type=style&index=0&id=61090abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61090abc",
  null
  
)

export default component.exports